<template>
  <div>
    <ui-dialog :heading="heading" @cancel="$emit('cancel')">
      <ui-input
        :label="label"
        v-model="internalValue"
        @keyup.enter.native="submit"
        autofocus
      />
      <template slot="footer">
        <ui-button @click.native="$emit('cancel')" tertiary>
          Abbrechen
        </ui-button>
        <ui-button
          @click.native="submit"
          :disabled="isDisabled"
          data-test="submit"
        >
          OK
        </ui-button>
      </template>
    </ui-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import UiButton from "./UiButton.vue";
import UiInput from "./UiInput.vue";
import UiDialog from "./UiDialog.vue";

export default Vue.extend({
  components: {
    UiButton,
    UiInput,
    UiDialog
  },
  data() {
    return {
      internalValue: ""
    };
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ""
    }
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true
    }
  },
  computed: {
    isDisabled() {
      return this.internalValue.trim() === "";
    }
  },
  methods: {
    submit() {
      if (!this.isDisabled) {
        this.$emit("submit", this.internalValue);
      }
    }
  }
});
</script>
